module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daypartcloud@3-990a79effd42d3befe941400310662bc.png";